interface CardLabelProps
  extends React.DetailedHTMLProps<
    React.LabelHTMLAttributes<HTMLLabelElement>,
    HTMLLabelElement
  > {}

export default function CardLabel({
  children,
  className = '',
  ...rest
}: CardLabelProps) {
  return (
    <label className={`card-label ${className}`} {...rest}>
      {children}
    </label>
  );
}
